export default __webpack_public_path__ + "static/logo-agcom-ba9f78cda1c5c7b59fa9abc8e3a64fb0.webp";